import React, {
    Component
} from 'react';
import {
    resetPassword,
    setLoadingResetPassword,
    resetPasswordSuccess,
    resetPasswordError
} from '../../actions/AuthActions';
import {
    bindActionCreators
} from "redux";
import {
    connect
} from "react-redux";
import {
    path_login
} from '../../routes/Pathnames';
import {
    TRANSLATE_RESET_PASSWORD
} from '../../translates/Translates';

class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                email: '',
            },
        }
    }

    resetPassword = () => {
        this.props.setLoadingResetPassword();
        this.props.resetPassword(this.state.form.email).then(() => {
            this.props.resetPasswordSuccess();
            window.location.replace(path_login);
        }).catch(() => {
            this.props.resetPasswordError();
        })
    }

    handleChange = (event) => {
        let field = event.target.name;
        let value = event.target.value;
        this.setState(prevState => {
            let form = prevState.form;
            form[field] = value;
            return {
                ...prevState,
                form
            }
        })
    }

    render() {
        return (
            <section id="wrapper">
                <div className="login-register">
                    <div className="login-box card">
                        <div className="card-body">
                            <form className="form-horizontal form-material" id="loginform" method="post">
                                <h3 className="p-2 rounded-title mb-3">{TRANSLATE_RESET_PASSWORD}</h3>
                                <div className="form-group ">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="text" required placeholder="E-mail" />
                                    </div>
                                </div>
                                <div className="form-group text-center mt-3">
                                    <div className="col-xs-12">
                                        <button
                                            className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                                            type="button"
                                            onClick={this.resetPassword}>{TRANSLATE_RESET_PASSWORD}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingResetPassword,
        resetPassword,
        resetPasswordSuccess,
        resetPasswordError
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(ResetPassword);
